

import { useNavigate } from 'react-router-dom'
import ButtonV2 from '../../common/components/atom/ButtonV2/Button'
import HeaderTitleContent from '../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import { LISTBTN } from '../../common/components/organisme/SideBar/SideBar'
import styles from './HomePage.module.scss'
export default function HomePage() {

  const listBtn = LISTBTN.filter(btn => btn.path !== '/main/')
  const navigate = useNavigate()

  return (
    <>
        <HeaderTitleContent >Accueil</HeaderTitleContent>
        <div className={styles['content-btn']}>
     
          { listBtn.map((btn, index) => (
           <div className={styles['content-btn__item']} key={index}>
        <ButtonV2  spaceBetween  fullWidth height={50} onClick={() => {navigate(btn.path)}} variant='dashboard-btn-outlined' iconRightType={btn.icon} size='medium' color={'secondary'}>{btn.name}</ButtonV2>
        </div>
       ))
       } 
        

        </div>
    </>
  )
}
